module.exports = __webpack_public_path__ + "static/media/jhapa3.d9df1805.ogg";